<template>
  <b-tab active :title="tabTitle">
    <!--------------User Registration Form------------------>
    <div class="col-12 p-0">
      <b-row class="m-3">
        <div class="col">
          <b-form
            novalidate
            @reset="onReset"
            @submit.prevent="onRegister"
            v-if="show"
            class="mt-3"
            autocomplete="off"
          >
            <!-- User Details -->
            <b-row>
              <b-col>
                <b-form-group id="input-group-username">
                  <label label-for="username" class="col-md-12 p-0"
                    >Username:</label
                  >
                  <div class="col-12 p-0">
                    <div class="col-12 p-0 position-relative">
                      <b-form-input
                        id="username"
                        name="username"
                        v-model="form.username"
                        v-on:input="formValidationHandler('username')"
                        type="text"
                        class="input col-md-12"
                        autocomplete="off"
                        maxlength="32"
                        placeholder="username"
                      ></b-form-input>
                      <div class="infoDiv infoDivIcon">
                        <i
                          class="fas fa-info-circle"
                          title="It can have either alphanumeric or special characters (. or _)"
                        ></i>
                      </div>
                    </div>
                    <div class="col-12 p-0">
                      <small
                        class="field-text is-danger text-danger"
                        v-html="errors.username"
                      ></small>
                    </div>
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="input-group-email">
                  <label label-for="email" class="col-md-12 p-0"
                    >Email address:</label
                  >
                  <div class="col-12 p-0">
                    <b-form-input
                      id="email"
                      name="email"
                      v-model="form.email"
                      v-on:input="formValidationHandler('email')"
                      type="email"
                      class="input col-md-12"
                      autocomplete="off"
                      maxlength="45"
                      placeholder="abc@evalueserve.com"
                    ></b-form-input>
                    <div class="col-12 p-0">
                      <small class="field-text is-danger text-danger">{{
                        errors.email
                      }}</small>
                    </div>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Name Fields -->
            <b-row>
              <b-col>
                <b-form-group id="input-group-first_name">
                  <label label-for="first_name" class="col-md-12 p-0"
                    >First Name:</label
                  >
                  <div class="col-12 p-0">
                    <b-form-input
                      id="first_name"
                      name="first_name"
                      v-model="form.first_name"
                      v-on:input="formValidationHandler('first_name')"
                      class="input col-md-12"
                      maxlength="20"
                      placeholder="first name"
                    ></b-form-input>
                    <div class="col-12 p-0">
                      <small class="field-text is-danger text-danger">{{
                        errors.first_name
                      }}</small>
                    </div>
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="input-group-last_name">
                  <label label-for="last_name" class="col-md-12 p-0"
                    >Last Name:</label
                  >
                  <div class="col-12 p-0">
                    <b-form-input
                      id="last_name"
                      name="last_name"
                      v-model="form.last_name"
                      v-on:input="formValidationHandler('last_name')"
                      class="input col-md-12"
                      autocomplete="off"
                      maxlength="20"
                      placeholder="last name"
                    ></b-form-input>
                    <div class="col-12 p-0">
                      <small class="field-text is-danger text-danger">{{
                        errors.last_name
                      }}</small>
                    </div>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Contact Details -->
            <b-row>
              <b-col>
                <b-form-group id="input-group-phonenumber">
                  <label label-for="phonenumber" class="col-md-12 p-0"
                    >Phone Number:</label
                  >
                  <div class="col-12 p-0">
                    <b-form-input
                      id="phonenumber"
                      name="phonenumber"
                      v-model="form.phonenumber"
                      v-on:input="formValidationHandler('phonenumber')"
                      type="tel"
                      class="input col-md-12"
                      autocomplete="off"
                      maxlength="10"
                      placeholder="0123456789"
                    ></b-form-input>
                    <div class="col-12 p-0">
                      <small class="field-text is-danger text-danger">{{
                        errors.phonenumber
                      }}</small>
                    </div>
                  </div>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group id="input-group-mobile_number">
                  <label label-for="mobilenumber" class="col-md-12 p-0"
                    >Mobile Number:
                  </label>
                  <div class="col-12 p-0">
                    <b-form-select
                      id="mobilecountrycode"
                      name="mobilecountrycode"
                      v-model="form.mobilecountrycode"
                      v-on:input="formValidationHandler('mobilecountrycode')"
                      :options="countryCodesList"
                      class="col-md-5"
                      required
                    ></b-form-select>
                    <b-form-input
                      id="mobilenumber"
                      name="mobilenumber"
                      v-model="form.mobilenumber"
                      v-on:input="formValidationHandler('mobilenumber')"
                      type="tel"
                      class="input col-md-7 p-0 pl-2 position-relative mobilenumber"
                      autocomplete="off"
                      maxlength="10"
                      placeholder="9876543210"
                    ></b-form-input>
                    <div class="row">
                      <div class="col-4">
                        <small class="field-text is-danger text-danger">{{
                          errors.mobilecountrycode
                        }}</small>
                      </div>
                      <div class="col-8 pl-1">
                        <small class="field-text is-danger text-danger">{{
                          errors.mobilenumber
                        }}</small>
                      </div>
                    </div>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- Role fields -->
            <b-row>
              <b-col>
                <b-form-group id="input-group-role">
                  <label label-for="role" class="col-md-12 p-0">Role:</label>
                  <div class="col-12 p-0">
                    <b-form-select
                      id="role"
                      v-model="form.role"
                      :options="roleList"
                      class="form-control col-md-12"
                      required
                    ></b-form-select>
                  </div>
                  <div class="col-12">
                    <small
                      v-if="!validRoleSelectValue.valid"
                      class="field-text text-danger errorText"
                      >{{ validRoleSelectValue.error }}</small
                    >
                  </div>
                </b-form-group>
              </b-col>
              <b-col></b-col>
            </b-row>
            <b-button type="reset" variant="primary" class="float-right mt-md-2"
              >Reset
            </b-button>
            <b-button
              type="submit"
              variant="success"
              class="float-right mt-2 mr-2"
              >Submit</b-button
            >
          </b-form>
        </div>
      </b-row>
    </div>
  </b-tab>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import {
  userInputValidation,
  validateUsername,
  validateFirstName,
  validateLastName,
  validateEmail,
  validatePhone,
  validateCountryCode,
  validateRepeatPassword,
  validateRole,
} from "@/helpers/form-validation.js";
export default {
  name: "UserRegistration",
  computed: {
    ...mapGetters({
      countryCodes: "countryCodes",
      isUserCreated: "isUserCreated",
    }),
  },
  data() {
    return {
      tabTitle: "User Registration",
      loader: "bars",
      show: true,
      form: {
        username: "",
        email: "",
        first_name: "",
        last_name: "",
        phonenumber: "",
        mobilenumber: "",
        mobilecountrycode: null,
        remark: "User creation",
        role: "user",
        errors: {},
        valid: true,
        firsttimelogin: true,
        status: "pending",
      },
      selectedRole: "admin",
      roleList: [
        { value: "admin", text: "Admin" },
        { value: "analyst", text: "Analyst" },
        { value: "user", text: "User" },
      ],
      errors: {},
      countryCodesList: [],
      validRoleSelectValue: {},
      phonenumber: "",
    };
  },
  methods: {
    ...mapActions(["registeradmin", "setUserCreatedToFalse"]),
    userInputValidation,
    validateUsername,
    validateFirstName,
    validateLastName,
    validateEmail,
    validatePhone,
    validateCountryCode,
    validateRepeatPassword,
    validateRole,
    async onReset(evt) {
      evt.preventDefault();
      // Trick to reset/clear native browser form validation state
      this.reset();
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    async reset() {
      // Reset our form values
      this.form.username = "";
      this.form.email = "";
      this.form.first_name = "";
      this.form.last_name = "";
      this.form.phonenumber = "";
      this.form.mobilenumber = "";
      this.form.mobilecountrycode = "";
      this.errors = {};
      this.setUserCreatedToFalse();
    },
    async onRegister($event) {
      this.errors = {};
      let validUserName = this.validateUsername(this.form.username);
      this.errors.username = validUserName.error;
      let validFirstName = this.validateFirstName(this.form.first_name);
      this.errors.first_name = validFirstName.error;
      let validLastName = this.validateLastName(this.form.last_name);
      this.errors.last_name = validLastName.error;
      let validEmail = this.validateEmail(this.form.email);
      this.errors.email = validEmail.error;
      let validPhone = this.validatePhone(this.form.phonenumber);
      this.errors.phonenumber = validPhone.error;
      let validMobile = this.validatePhone(this.form.mobilenumber);
      this.errors.mobilenumber = validMobile.error;
      let validCountryCode = this.validateCountryCode(
        this.form.mobilecountrycode
      );
      this.errors.mobilecountrycode = validCountryCode.error;
      let validRole = this.validateRole(this.form.role);
      this.errors.role = validRole.error;
      // console.log(
      //   "========",
      //   validUserName.valid,
      //   validFirstName.valid,
      //   validLastName.valid,
      //   validEmail.valid,
      //   validPhone.valid,
      //   validMobile.valid,
      //   validCountryCode.valid,
      //   validRole.valid
      // );
      if (
        validUserName.valid &&
        validFirstName.valid &&
        validLastName.valid &&
        validEmail.valid &&
        validPhone.valid &&
        validMobile.valid &&
        validCountryCode.valid &&
        validRole.valid
      ) {
        this.form.valid = true;
      } else {
        this.form.valid = false;
      }
      // console.log("11111111111-------------------------------");
      // console.log("this.valid", this.form.valid);
      if (this.form.valid) {
        let response = await this.registeradmin(this.form);
        console.log("response++++", response);
        if (response.status === 202 || response.status === 201) {
          this.onReset($event);
        }
        // this.reset();
      }
    },
    formValidationHandler(val) {
      console.log("val+++++++++++===", this.form[val]);
      let les = this.userInputValidation(this.form[val]);
      this.form[val] = "";
      this.form[val] = les;
      if (val === "username") {
        this.validUserName = this.validateUsername(this.form.username);
        this.errors.username = this.validUserName.error;
      }
      if (val === "first_name") {
        this.validFirstName = this.validateFirstName(this.form[val]);
        this.errors[val] = this.validFirstName.error;
      }
      if (val === "last_name") {
        this.validLastName = this.validateLastName(this.form.last_name);
        this.errors.last_name = this.validLastName.error;
      }
      if (val === "email") {
        this.validEmail = this.validateEmail(this.form.email);
        if (this.validEmail.valid) {
          let emailV = this.evalueserveEmailValidator(this.form.email);
          this.validEmail.valid = emailV;
          if (!emailV) {
            this.errors.email = "Please enter evalueserve email only.";
          } else {
            this.errors.email = null;
          }
        } else {
          this.errors.email = this.validEmail.error;
        }
      }
      if (val === "mobilenumber" || val === "phonenumber") {
        let phonenumberArr = this.form[val].toString().split("");
        let sum = phonenumberArr.reduce(function(a, b) {
          return parseInt(a) + parseInt(b);
        }, 0);
        if (isNaN(sum)) {
          setTimeout(() => {
            this.form[val] = "";
          }, 10);
          this[val] = {
            valid: false,
            error: "Please, enter a valid number.",
          };
        } else {
          if (sum > 0) {
            this[val] = this.validatePhone(this.form[val]);
          } else {
            this[val] = {
              valid: false,
              error: "Please, enter a valid number.",
            };
          }
        }
        this.errors[val] = this[val].error;
      }
      if (val === "mobilecountrycode") {
        this.validMobilecountrycode = this.validateCountryCode(
          this.form.mobilecountrycode
        );
        this.errors.mobilecountrycode = this.validMobilecountrycode.error;
        // console.log("this.validMobilecountrycode", this.validMobilecountrycode);
      }
      if (val === "password") {
        this.validPassword = this.validatePassword(
          this.form.password,
          this.form.password_repeat
        );
        if (this.form.password_repeat.length) {
          this.validRepeatPassword = this.validateRepeatPassword(
            this.form.password,
            this.form.password_repeat,
            val
          );
          this.errors.password_repeat = this.validRepeatPassword.error;
        }
        this.errors.password = this.validPassword.error;
      }
      if (val === "password_repeat") {
        // console.log("+++++++++++++", val);
        this.validRepeatPassword = this.validateRepeatPassword(
          this.form.password,
          this.form.password_repeat,
          val
        );
        this.errors.password_repeat = this.validRepeatPassword.error;
      }
      if (val === "role") {
        this.validRoleSelectValue = this.validateRole(this.form.role);
        this.errors.role = this.validRoleSelectValue.error;
      }
    },
    evalueserveEmailValidator(ctrl) {
      return ctrl.endsWith("@evalueserve.com");
    },
  },
  mounted() {
    this.setUserCreatedToFalse();
  },
  watch: {
    countryCodes: {
      deep: true,
      handler() {
        this.countryCodesList = [];
        this.countryCodesList = JSON.parse(JSON.stringify(this.countryCodes));
        this.countryCodesList.unshift({
          value: null,
          text: "Select country code",
          disabled: true,
        });
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.form-group {
  margin: 0 !important;
}
</style>
